<template>

    <b-container class="py-4" :class="[{ 'pt-5 mt-5': isIE }]">
        <b-overlay
            :show="report_download_loading"
            rounded="sm"
            blur="0"
            opacity="0.7"
            z-index="9999"
        >

            <b-row>
                <b-col cols="12">
                    <h1 class="mb-45 mt-m1 fw-600">
                        {{ $t('평가 참여하기') }}
                    </h1>
                </b-col>
            </b-row>
            <!-- <b-row class="mb-4">
                <b-col cols="12" md="12">
                    <SystemNotification />
                </b-col>
            </b-row> -->
            <template v-if="!is_campaigns_loaded">
                <b-row>
                    <b-col cols="12">
                        <b-row>
                            <b-col>
                                <b-skeleton-img height="150px"></b-skeleton-img>
                            </b-col>
                            <b-col>
                                <b-skeleton-img height="150px"></b-skeleton-img>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </template>
            <template v-else-if="is_campaigns_loaded && !campaign_num">
                <b-row class="mb-4">
                    <b-col>
                        <!-- 결제 완료되고, 기본 정보 입력이 되지 않았을 때 -->
                        <b-card class="shadow-sm py-3">
                            <h5 class="gray-600 mb-4">{{ $t('참여 가능한 평가가 없습니다.') }}</h5>
                            <p class="gray-500 fw-400">
                                {{ $t('기본정보 입력 후 참여할 평가가 생성됩니다.') }}
                            </p>
                            <p class="gray-500 mb-0 fw-400">
                                <fa icon="exclamation-circle" class="mr-1"></fa>
                                {{ $t('기본정보 입력 후에도 평가가 보이지 않는다면') }}
                                <a class="dark-a-under" href="mailto:info@qesg.co.kr"> {{ $t('문의해주세요.') }} </a>
                            </p>
                        </b-card>
                    </b-col>
                </b-row>
            </template>
            <template v-else-if="is_campaigns_loaded && campaign_num">
                <b-row v-for="(status, status_idx) in seperated_campaigns" :key="`campaigns-group-${status.state}`"
                       :class="[{ 'mt-4': status_idx > 0 }]">
                    <b-col cols="12">
                        <h4 class="mb-2">
                            {{ status.state === 'ongoing' ? $t('진행중인 평가') : $t('완료된 평가') }}
                        </h4>
                    </b-col>

                    <template v-if="!status.campaigns.length">
                        <b-col cols="12">
                            <b-card class="bgray-50 p-3" no-body>
                                <h6 class="mb-0">
                                    {{ $t(`아직 ${status.state === 'ongoing' ? '진행중인 평가' : '완료된 평가'}가 없습니다.`) }}
                                </h6>
                            </b-card>
                        </b-col>
                    </template>
                    <template v-else>
                        <b-col v-for="(campaign, campaign_idx) in status.campaigns"
                               :key="`campaigns-group-${status.state}-${campaign_idx}-${campaign.id}`" cols="12" lg="5"
                               class="mb-3 mb-md-4">
                            <b-card class="intro-camp-card position-relative shadow-sm"
                                    :class="[{ 'bgray-300': campaign.campaign_state !== '답변중' || campaign.campaign_access_status === '1' }]"
                                    no-body
                            >

                                <div class="d-flex flex-column flex-grow-1 cursor p-3" @click="enterCampaign(campaign)">
                                    <div class="d-flex justify-content-between mb-2">
                                        <h4 class="mb-0">
                                            {{
                                                showTranslation(campaign.campaign_name, campaign.campaign_name_e, campaign.campaign_name_c)
                                            }}
                                        </h4>

                                        <div v-if="campaign.campaign_state !== '답변중'">
                                            <b-badge v-b-tooltip.hover class="ml-2 fw-600"
                                                     :title="$t('편집중이거나 종료된 평가입니다')"
                                                     variant="emerging" pill>

                                                {{ campaign.campaign_state !== '답변중' ? 'Closed' : '' }}
                                            </b-badge>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="w-xs-100 w-md-50">
                                            <p class="fw-95 mb-0">{{ $t('프로젝트 코드') }}</p>
                                            <div class="f-105 gray-650 fw-400">{{ campaign.project_code }}</div>
                                        </div>
                                        <div class="w-xs-100 w-md-50">
                                            <p class="fw-95 mb-0">{{ $t('평가신청 기업') }}</p>
                                            <div class="f-105 gray-650 fw-400 text-truncate"
                                                 :title="campaign.company_name"
                                            >
                                                {{ campaign.company_name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <template
                                    v-if="(!!report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`]) || !!campaign.actionplan">
                                    <div class="px-3 pb-3">
                                        <template
                                            v-if="!!report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`]">
                                            <b-dropdown :text="$t('결과보고서 보기')" size="sm" variant="primary"
                                                        :class="[{'mr-2': !!campaign.actionplan }]"
                                            >
                                                <b-dropdown-item
                                                    v-if="report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`]['DOC']"
                                                    @click.stop="showCompanyReport(
                                                    report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`],
                                                    'DOC'
                                                )"
                                                >
                                                    {{ `${$t('서면평가')} ${$t('결과보고서')}` }}
                                                </b-dropdown-item>
                                                <b-dropdown-item
                                                    v-if="report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`]['DOC']"
                                                    @click.stop="downloadResultReport(report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`], 'DOC')"
                                                >
                                                    {{ $t('서면평가 결과보고서 다운로드') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item
                                                    v-if="report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`]['OSIS']"
                                                    @click.stop="showCompanyReport(
                                                    report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`],
                                                    'OSIS'
                                                )"
                                                >
                                                    {{ `${$t('실사평가')} ${$t('결과보고서')}` }}
                                                </b-dropdown-item>
                                                <b-dropdown-item
                                                    v-if="report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`]['OSIS']"
                                                    @click.stop="downloadResultReport(report_by_campaign[`${campaign.campaign_id}_${campaign.request_company_id}`], 'OSIS')"
                                                >
                                                    {{ $t('실사평가 결과보고서 다운로드') }}
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </template>

                                        <template v-if="campaign.actionplan?.length > 0">
                                            <b-btn size="sm" variant="danger"
                                                   @click.stop="managingActionPlan(campaign)"
                                            >
                                                {{ $t('개선계획서 제출') }}
                                            </b-btn>
                                        </template>
                                    </div>
                                </template>

                                <template v-if="campaign.client">
                                    <div
                                        class="d-flex justify-content-between align-items-center bg-light f-95 rounded-bottom border-top px-3 py-2">
                                        <div>
                                            <template
                                                v-if="(typeof campaign.status_code !== 'undefined') && campaign.campaign_access_status === 0">
                                                <b-badge :variant="badges(campaign.status_code)"
                                                         :class="[{ 'mr-2': ['1', '2'].includes(campaign.campaign_access_status) }, 'f-85 fw-400 mr-2']">
                                                    {{ status_txt(campaign.status_code) }}
                                                </b-badge>
                                            </template>
                                            <template
                                                v-if="!['completed', 'canceled'].includes(campaign.status_code) && campaign.campaign_access_status !== 0">
                                                <b-badge
                                                    :variant="campaign_access_status_mapping_color(campaign.campaign_access_status)"
                                                    :class="['f-85 fw-400 gray-700', { 'text-light': campaign.campaign_access_status !== 1 }, { 'text-dark': campaign.campaign_access_status === 1 }]">
                                                    {{
                                                        $t(campaign_access_status_mapping(campaign.campaign_access_status))
                                                    }}
                                                </b-badge>
                                            </template>
                                        </div>
                                        <div class="f-90 gray-550 fw-300">
                                            {{ date_to_string(campaign.requested_ts) }} ~
                                            {{ date_to_string(campaign.duedate_ts) }}
                                        </div>
                                    </div>
                                </template>
                            </b-card>
                        </b-col>
                    </template>
                </b-row>

                <!-- <b-modal id="modal-campaign-report-list" title="결과보고서 목록"
                    @hidden="view_target_report_company_id = null" size="xl"
                    centered
                    >
                    view_target_report_company_id {{ view_target_report_company_id }}
                    {{ report_by_campaign[view_target_report_company_id] }}
                    <b-table :items="report_by_campaign[view_target_report_company_id]"
                        :fields="[
                            { key: 'project_code', label: $t('프로젝트 코드') },
                            { key: 'campaign_name', label: $t('캠페인') },
                            { key: 'mode', label: $t('평가유형') },
                            { key: 'report_name', label: $t('결과보고서명'), tdStyle: 'text-break-all' },
                            { key: 'time_stamp', label: $t('결과보고서 생성일') },
                            { key: 'view_report', label: $t('결과보고서 보기') }
                        ]"
                        >
    
                        <template #cell(mode)="data">
                            <div class="text-nowrap">
                                {{ data.value === "DOC" ? $t('서면평가') : $t('실사평가') }}
                            </div>
                        </template>
    
                        <template #cell(time_stamp)="data">
                            <div class="text-nowrap">
                                {{ formatDate(data.value) }}
                            </div>
                        </template>
    
                        <template #cell(view_report)="data">
                            <b-btn size="sm" @click="showCompanyReport(data.item)">{{ $t('결과보고서 보기') }}</b-btn>
                        </template>
                    </b-table>
                </b-modal> -->

                <template v-if="view_target_report">
                    <b-modal id="showing-campaign-report" :title="$t('결과보고서 보기')" body-bg-variant="white"
                             size="xl"
                             hide-footer
                             centered
                             scrollable
                             @hidden="initializeReportViewer"
                    >
                        <ReportViewerContainer
                            :report_lang="report_lang"
                            :view_target_report="view_target_report"
                            :view="true"
                        />
                    </b-modal>
                </template>

                <template v-if="actionplan_campaign?.company_name">
                    <b-modal id="managing-campaign-actionplan"
                             :title="`${actionplan_campaign.company_name} - ${$t('개선계획 제출')}`"
                             body-bg-variant="white" size="lg" hide-footer centered
                             :no-close-on-backdrop="is_submitting_actionplan"
                             :no-close-on-esc="is_submitting_actionplan" @hidden="actionplan_campaign = null">
                        <b-row
                            :class="[current_campaign?.actionplan.length > 1 ? 'align-items-top' : 'align-items-center']">
                            <b-col cols="6">
                                <h4> {{ $t('개선계획서 제출') }} </h4>
                            </b-col>
                            <b-col cols="6">
                                <div v-if="current_campaign?.actionplan.length > 1"
                                     class="d-flex justify-content-end align-items-center">
                                    <span class="f-95 mr-3">{{ $t('개선계획서 버전') }}:</span>
                                    <b-form-select :value="actionplan_index"
                                                   style="width: 200px"
                                                   @change="selectActionPlan"
                                    >
                                        <b-form-select-option v-for="(actionplan, index) in current_campaign.actionplan"
                                                              :key="`actionplan-${index}`" :value="index">
                                            {{ actionplan_name(actionplan, index) }}
                                        </b-form-select-option>
                                    </b-form-select>
                                </div>
                                <div class="text-danger text-right text-underline"
                                     :class="{'mb-2': current_campaign?.actionplan.length > 1}"
                                >
                                    {{
                                        $t('actionPlanDueDate', {dueDate: calculateActionplanRestDate(actionplan_campaign.audit_sended_at)})
                                    }}
                                </div>
                            </b-col>
                        </b-row>

                        <b-card no-body>
                            <b-row no-gutters>
                                <template v-if="!actionplan_campaign.is_questionnaire_download_block">
                                    <b-col cols="12" lg="6" class="border-right bgray-100">
                                        <div class="bg-white border-bottom rounded-top px-3 py-2">
                                            <h5 class="f-110 mb-0">{{ $t('개선계획서 다운로드') }} </h5>
                                        </div>
                                        <div class="d-flex flex-column p-3">

                                            <p v-if="actionplan_campaign.is_current" class="f-95 mb-5">
                                                {{ $t('아래 ‘개선계획서’를 다운로드 받으신 후 ‘E~F’열을 작성해주시기 바랍니다.') }}

                                            </p>
                                            <p v-else class="f-95 mb-5">
                                                {{ $t('이전 버전의 ‘개선계획서’입니다. 참고용으로 사용하시기 바랍니다.') }}
                                            </p>

                                            <div class="text-center">
                                                <b-btn class="mr-2" variant="info"
                                                       :disabled="is_submitting_actionplan || actionplan_campaign.is_questionnaire_download_block"
                                                       pill
                                                       @click="downloadActionPlanFile(actionplan_campaign)">
                                                    {{ $t('개선계획서 다운로드') }}
                                                </b-btn>
                                            </div>
                                        </div>
                                    </b-col>
                                </template>
                                <b-col cols="12" :lg="actionplan_campaign.is_questionnaire_download_block ? 12 : 6"
                                       class="bgray-100">
                                    <template v-if="actionplan_campaign.is_current">
                                        <div class="border-bottom bg-white rounded-top px-3 py-2">
                                            <h5 class="f-110 mb-0">{{ $t('개선계획서 업로드') }} </h5>
                                        </div>
                                        <div class="p-3">
                                            <p class="f-95">{{ $t('작성하신 개선계획서 엑셀 파일을 업로드 해주시기 바랍니다.') }} </p>

                                            <b-form-group id="fieldset-input-company-actionplan-file"
                                                          :label="$t('개선계획서 제출하기') "
                                                          label-for="input-company-actionplan-file" class="mb-3"
                                                          :disabled="is_submitting_actionplan">
                                                <b-form-file id="input-company-actionplan-file"
                                                             ref="company-actionplan-file"
                                                             v-model="actionplan_campaign.company_submitting_file"
                                                             class="mb-0"
                                                             :browse-text="$t('파일 선택')"
                                                             :placeholder="$t('제출하실 개선계획서 선택')"
                                                             :disabled="is_submitting_actionplan"/>
                                            </b-form-group>

                                            <div class="text-right">
                                                <b-btn-group>
                                                    <template v-if="actionplan_campaign.company_file_key">
                                                        <b-btn variant="secondary"
                                                               :disabled="actionplan_campaign.company_file_key === null || is_submitting_actionplan"
                                                               size="sm"
                                                               @click="downloadSubmittedActionPlanFile(actionplan_campaign)">
                                                            {{ $t('제출 파일 다운로드') }}
                                                        </b-btn>
                                                    </template>
                                                    <b-btn variant="primary"
                                                           :disabled="actionplan_campaign.company_submitting_file === null || is_submitting_actionplan"
                                                           size="sm"
                                                           @click="confirmSubmitCompanyActionPlan">
                                                        <span v-show="!is_submitting_actionplan"> {{
                                                                $t('제출하기')
                                                            }} </span>
                                                        <div
                                                            :class="[is_submitting_actionplan ? 'd-flex' : 'd-none', 'align-items-center']">
                                                            <span class="mr-1">{{ $t('전송중') }}...</span>
                                                            <b-spinner style="width: 0.9rem;height: 0.9rem;"/>
                                                        </div>
                                                    </b-btn>
                                                    <b-btn variant="danger"
                                                           :disabled="actionplan_campaign.company_submitting_file === null || is_submitting_actionplan"
                                                           size="sm"
                                                           @click="actionplan_campaign.company_submitting_file = null">
                                                        {{ $t('초기화') }}
                                                    </b-btn>
                                                </b-btn-group>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="border-bottom bg-white rounded-top px-3 py-2">
                                            <h5 class="f-110 mb-0"> {{ $t('개선계획서') }} </h5>
                                        </div>
                                        <div class="p-3">
                                            <template v-if="actionplan_campaign.company_file_key">
                                                <p class="f-95 mb-5">
                                                    {{ $t('이전에 제출한 ‘개선계획서’입니다. 참고용으로 사용하시기 바랍니다.') }}
                                                </p>

                                                <div class="text-center">
                                                    <b-btn variant="secondary"
                                                           :disabled="actionplan_campaign.company_file_key === null || is_submitting_actionplan"
                                                           size="sm"
                                                           @click="downloadSubmittedActionPlanFile(actionplan_campaign)">
                                                        {{ $t('제출 파일 다운로드') }}

                                                    </b-btn>
                                                </div>

                                            </template>
                                            <template v-else>
                                                <p class="d-flex flex-column align-items-center justify-content-center h-100 f-95">
                                                    {{ $t('제출된 파일이 없습니다.') }}
                                                </p>
                                            </template>
                                        </div>
                                    </template>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-modal>
                </template>
            </template>
            <template #overlay>
                <div></div>
            </template>
        </b-overlay>
        <div v-if="report_download_loading" class="report-loading-overlay" style="height: 100vh;">
            <div class="text-center">
                <b-spinner variant="primary" style="width: 3rem; height: 3rem;" class="mx-auto"></b-spinner>
                <p class="mt-3 mb-0 text-dark font-weight-bold" style="font-size: 1.1rem;">
                    {{ $t('결과보고서 다운로드 중입니다...') }}
                </p>
            </div>
        </div>
    </b-container>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import {mapState, mapActions, mapMutations} from 'vuex';
import dayjs from 'dayjs';
import * as ih from '@core_utils/util';
import DetectIe from '@shared_mixins/detect_ie';
import downloadFile from '@shared_mixins/downloadFile';
import ReportViewerContainer from '@shared_components/admin/components/report/ReportViewerContainer.vue';
// import SystemNotification from '@shared_components/common/system-notification.vue'

export default {
    name: 'IntroLanding',
    components: {
        ReportViewerContainer
        // SystemNotification
    },
    mixins: [
        DetectIe,
        downloadFile
    ],
    data() {
        return {
            is_campaigns_loaded: false,
            is_submitting_actionplan: false,
            actionplan_campaign: {
                actionplan_id: null,
                request_id: null,
                company_name: null,
                audit_sended_at: null,
                auditor_file_ext: null,
                auditor_file_key: null,
                auditor_filename: null,
                company_file_ext: null,
                company_file_key: null,
                company_filename: null,
                company_submitted_at: null,
                company_submitting_file: null,
                is_current: false,
            },
            current_campaign: null,
            actionplan_index: null,

            // Report
            report_lang: 'ko',
            report_by_campaign: {},
            lang_pattern: /(KOR|CHI|CHN|ENG)/g,
            lang_pattern_pair: {KOR: 'ko', CHI: 'ca', ENG: 'en', CHN: 'ca'},

            // view
            is_viewing_report: false,
            view_target_report: null,
            view_target_report_company_id: null,

            report_download_loading: false,
            scrollPosition: 0,
        };
    },
    computed: {
        ...mapState(['campaigns', 'seperated_campaigns', 'campaign_num', 'campaign_in_progress', 'user_id', 'user_name', 'company_id', 'is_admin']),
        ...mapState('industry_campaigns', ['custom_project_code', 'custom_template', 'custom_template_loaded']),
        ...mapState('dashboard', ['camp_not_completed', 'camp_id']),
        actionplan_name() {
            return (actionplan, index) => {
                const version = this.current_campaign.actionplan.length - index;
                if (index === 0) {
                    return `v${version} - ${this.$t('현재 버전')}`;
                } else {
                    return `v${version} - ${this.$t('이전 버전')}`;
                }
            };
        }
    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler(_i18n_lang) {
                this.report_lang = _i18n_lang;
            }
        },
        view_target_report_company_id(_rh_target_company_id) {
            if (_rh_target_company_id !== null) {
                this.$bvModal.show('modal-campaign-report-list');
            }
        },
        report_download_loading(newVal) {
            // 다운로드 중일 때 html과 body 스크롤 제거
            if (newVal) {
                this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                document.documentElement.style.overflow = 'hidden';
                document.body.style.overflow = 'hidden';
            } else {
                document.documentElement.style.overflow = '';
                document.body.style.overflow = '';
                window.scrollTo(0, this.scrollPosition);
            }
        }
    },
    async created() {
        this.report_lang = this.$i18n.locale;
        this.is_campaigns_loaded = false;
        if (this.isIE) {
            this.$store.commit('update_login_alert', true);
        } else {
            await this.createdInitiate();
            // this.report_lang = this.$i18n.locale
        }
    },
    beforeDestroy() {
        this.is_campaigns_loaded = false;
        // html과 body overflow 복구
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        window.scrollTo(0, this.scrollPosition);
    },
    methods: {
        ...mapActions('campaign_users', ['readUsersByCompany']),
        ...mapActions(['read_recieved_campaigns', 'read_company_recieved_campaigns']),
        ...mapMutations('industry_campaigns', ['update_custom_project_code']),
        ...mapActions('industry_campaigns', ['readCustomTemplate']),
        ...mapMutations(['add_custom_template', 'change_login_company', 'update_campaign_actionplan']),
        ...mapMutations('dashboard', ['set_temp_campaign']),
        ...mapMutations('attachments', ['initAttachmentsStorage']),
        ...mapActions('attachments', ['getAttatchments']),
        async logoutAndNavigate() {
            await this.$store.dispatch('logout');
            this.$router.push({name: 'Register'});
        },
        async createdInitiate() {
            try {
                if (!localStorage.getItem('company_id') || !localStorage.getItem('company_name')) {
                    await this.$store.dispatch('logout');
                    return false;
                }

                if (localStorage.getItem('company_id') && localStorage.getItem('company_name') && localStorage.getItem('company_id') !== this.company_id) {
                    this.change_login_company({
                        company_name: localStorage.getItem('company_name'),
                        company_id: localStorage.getItem('company_id')
                    });
                }

                await this.read_company_recieved_campaigns({user_id: this.user_id});

                if (this.seperated_campaigns[1].campaigns) {
                    let _has_released_report = false;
                    const Promise_Request_ReportHistory = this.seperated_campaigns[1].campaigns.reduce((RH_Promise, _campaign) => {
                        RH_Promise.push(this.$axios.get('/report/history', {
                            params: {
                                campaign_id: _campaign.campaign_id,
                                project_code: _campaign.project_code,
                                company_id: _campaign.request_company_id,
                                is_send_mail: 1
                            }
                        }).then(({data}) => {
                            return data.result;
                        }));

                        return RH_Promise;
                    }, []);

                    let _requested_RH = await Promise.all(Promise_Request_ReportHistory);
                    _requested_RH = _requested_RH.flat();
                    this.report_by_campaign = this.seperated_campaigns[1].campaigns.reduce((_report_by_campaign, _campaign) => {
                        const {campaign_id, request_company_id, project_code} = _campaign;

                        const _campaign_rhs = _requested_RH.filter(({
                            company_id: rh_company_id,
                            campaign_id: rh_campaign_id,
                            project_code: rh_project_code,
                            confirmed
                        }) =>
                            rh_campaign_id === campaign_id && rh_company_id === request_company_id && rh_project_code === project_code && confirmed
                        );

                        if (_campaign_rhs.length) {
                            const _campaign_rh_DOC = _campaign_rhs.find(({mode}) => mode === 'DOC');
                            const _campaign_rh_OSIS = _campaign_rhs.find(({mode}) => mode === 'OSIS');
                            const report_lang_doc = this.lang_pattern_pair?.[_campaign_rh_DOC?.report_name.match(this.lang_pattern)?.[0]];
                            const report_lang_osis = this.lang_pattern_pair?.[_campaign_rh_OSIS?.report_name.match(this.lang_pattern)?.[0]];

                            _report_by_campaign[`${campaign_id}_${request_company_id}`] = {
                                DOC: !_campaign_rh_DOC ? null : {
                                    ..._campaign_rh_DOC,
                                    report_lang: report_lang_doc ?? 'ko',
                                },
                                OSIS: !_campaign_rh_OSIS ? null : {
                                    ..._campaign_rh_OSIS,
                                    report_lang: report_lang_osis ?? 'ko',
                                }
                            };
                            this.report_lang = report_lang_doc ?? report_lang_osis ?? 'ko';
                        }

                        return _report_by_campaign;
                    }, {});

                    if (_has_released_report) {
                        await this.$report.loadFont();
                    }
                }

                if (!this.camp_id) {
                    if (this.seperated_campaigns && this.campaign_num > 0) {
                        this.set_temp_campaign(this.seperated_campaigns);
                    }
                }
                this.is_campaigns_loaded = true;
            } catch (error) {
                await this.common_error_handling();
            }
        },
        async enterCampaign(campaign) {
            if (campaign.campaign_state === '생성/편집' && this.is_admin <= 2) {
                alert(this.$t('\'Closed\' 상태인 평가 캠페인은 접속하실 수 없습니다. 평가 세팅을 수정하고 있으니 잠시만 기다려주세요.'));
                return false;
            }

            if (campaign.status_code === 'canceled') {
                alert('평가 취소된 캠페인입니다. 다시 평가를 시작하시려면 새로 평가를 신청하여주십시오. (문의 : info@qesg.co.kr)');
                return false;
            }

            if (campaign.campaign_access_status !== 0) {
                let msg = this.$t('평가 질문지에 접근하기 위해서는 기업 평가 관리자의 승인이 필요합니다. 기업 평가 관리자에게 승인을 요청하십시오.');
                msg += `\n *${this.$t('기업 평가 관리자 정보')} ${campaign.company_manager}`;
                msg += `\n *${this.$t('기업 평가 관리자가 잘못된 정보로 판단되거나, 변경이 필요한 경우 info@qesg.co.kr 로 요청하여 주십시오.')}`;
                alert(msg);
                return false;
            }

            if (this.company_id !== campaign.request_company_id) {
                this.change_login_company({
                    company_name: campaign.company_name,
                    company_id: campaign.request_company_id
                });
            }

            this.$store.commit('update_login_alert', false);
            this.$store.commit('update_campaign_in_progress', campaign); // 1. store에 campaign_in_progress 커밋

            if (this.campaign_in_progress.template_code !== '' || this.campaign_in_progress.campaign_id !== '') {
                await this.$store.dispatch('readTemplateInProgress', {
                    template_code: this.campaign_in_progress.template_code,
                    company_id: campaign.request_company_id
                });

                this.update_custom_project_code(campaign.project_code);
                await this.readCustomTemplate({
                    project_code: campaign.project_code,
                    company_id: campaign.request_company_id
                });

                if (this.custom_template_loaded && this.custom_template.template_code) {
                    this.add_custom_template(this.custom_template);
                }
            }

            this.initAttachmentsStorage();
            await this.getAttatchments({company_id: campaign.request_company_id, campaign_id: campaign.campaign_id});

            await this.saveVisitLog(); //참여하러 평가 클릭했는지 log 저장
            this.$router.push({
                path: '/participate_preface',
                query: {
                    pc: campaign.project_code,
                    cmp: campaign.campaign_id,
                    cpn: campaign.request_company_id,
                    cpnm: campaign.company_name
                }
            });
        },
        initializingManagingActionPlan() {
            this.actionplan_campaign = {
                request_id: null, company_name: null, company_submitting_file: null,
                audit_sended_at: null, auditor_file_ext: null, auditor_file_key: null, auditor_filename: null,
                company_file_ext: null, company_file_key: null, company_filename: null, company_submitted_at: null,
                is_questionnaire_download_block: false, actionplan_id: null
            };
        },
        managingActionPlan(_campaign) {
            if (_campaign.actionplan.length > 0) {
                this.actionplan_index = 0;
            } else {
                return;
            }
            const {
                audit_sended_at, auditor_file_ext, auditor_file_key, auditor_filename,
                company_file_ext, company_file_key, company_filename, company_submitted_at,
                is_questionnaire_download_block, id
            } = _campaign.actionplan[0];
            const {request_id, company_name} = _campaign;

            this.actionplan_campaign = {
                request_id, company_name, actionplan_id: id,
                audit_sended_at, auditor_file_ext, auditor_file_key, auditor_filename,
                company_file_ext, company_file_key, company_filename, company_submitted_at,
                company_submitting_file: null, is_questionnaire_download_block, is_current: true,
            };
            this.current_campaign = _campaign;

            this.$nextTick(() => {
                this.$bvModal.show('managing-campaign-actionplan');
            });
        },
        selectActionPlan(index) {
            this.actionplan_index = index;

            const {
                audit_sended_at, auditor_file_ext, auditor_file_key, auditor_filename,
                company_file_ext, company_file_key, company_filename, company_submitted_at,
                is_questionnaire_download_block, id
            } = this.current_campaign.actionplan[index];
            this.actionplan_campaign = {
                ...this.actionplan_campaign,
                actionplan_id: id,
                audit_sended_at, auditor_file_ext, auditor_file_key, auditor_filename,
                company_file_ext, company_file_key, company_filename, company_submitted_at,
                is_questionnaire_download_block, is_current: index === 0,
            };
        },
        async downloadActionPlanFile({
            request_id,
            company_name,
            auditor_file_key,
            auditor_filename,
            auditor_file_ext,
            actionplan_id
        }) {
            try {
                const _res_audit_action_plan = await this.$axios.post('/actionplans/download',
                    {
                        actionplan_id,
                        request_id,
                        'mode': 'auditor'
                    }, {responseType: 'blob'}
                );
                this.downloadFileFromResponse(_res_audit_action_plan, `${company_name}_${auditor_filename}`, auditor_file_ext);
            } catch (error) {
                if (error.response) {
                    const {status} = error.response;
                    if (status === 404) {
                        alert(this.$t('죄송합니다. 해당 평가의 개선계획서가 조회되지 않습니다. QESG에 문의해주시기 바랍니다.'));
                        return false;
                    }
                }

                alert(this.$t('죄송합니다. 개선계획 과제 다운로드 중 장애가 발생했습니다. QESG에 문의해주시기 바랍니다.'));
            }
        },
        async downloadSubmittedActionPlanFile({
            request_id,
            company_name,
            company_filename,
            company_file_key,
            company_file_ext,
            actionplan_id
        }) {
            try {
                const _res_audit_action_plan = await this.$axios.post('/actionplans/download',
                    {
                        actionplan_id,
                        request_id,
                        'mode': 'company'
                    }, {responseType: 'blob'}
                );

                this.downloadFileFromResponse(_res_audit_action_plan, `${company_name}_${company_filename}`, company_file_ext);
            } catch (error) {
                if (error.response) {
                    const {status} = error.response;
                    if (status === 404) {
                        alert(this.$t('죄송합니다. 해당 평가의 개선계획서가 조회되지 않습니다. QESG에 문의해주시기 바랍니다.'));
                        return false;
                    }
                }

                alert(this.$t('죄송합니다. 개선계획 과제 다운로드 중 장애가 발생했습니다. QESG에 문의해주시기 바랍니다.'));
            }
        },
        confirmSubmitCompanyActionPlan() {
            if (!this.actionplan_campaign.company_submitting_file) {
                this.$refs['company-actionplan-file'].focus();
            } else {
                const h = this.$createElement;
                const msg = this.actionplan_campaign.company_file_key ?
                    h('div', {}, [
                        h('div', {}, this.$t('이전에 제출한 개선계획서가 있습니다.')),
                        h('div', {}, this.$t('새로운 개선계획서를 제출하시겠습니까?'))
                    ]) :
                    '작성하신 개선계획서를 제출하시겠습니까?';
                this.$showModal({
                    type: 'confirm',
                    state: 'info',
                    title: this.$t('개선계획서 제출'),
                    message: msg,
                })
                    .then(value => {
                        if (value) this.submitCompanyActionPlan();
                    });
            }
        },
        async submitCompanyActionPlan() {
            try {

                this.is_submitting_actionplan = true;
                const _actionplan_form = new FormData();
                _actionplan_form.append('actionplan_id', this.actionplan_campaign.actionplan_id);
                _actionplan_form.append('request_id', this.actionplan_campaign.request_id);
                _actionplan_form.append('submitter_id', this.user_id);
                _actionplan_form.append('company_actionplan', this.actionplan_campaign.company_submitting_file);

                const _res_sumbit_actionplan = await this.$axios.post('/actionplans/submit', _actionplan_form, {
                    headers: {
                        contentType: 'multipart/form-data'
                    }
                });

                let _campaign_state = null;
                let _campaign_ongoing_idx = this.seperated_campaigns[0].campaigns.findIndex(({request_id}) => request_id === this.actionplan_campaign.request_id);
                if (_campaign_ongoing_idx !== -1) {
                    _campaign_state = 0;
                }

                if (!_campaign_state) {
                    let _campaign_completed_idx = this.seperated_campaigns[1].campaigns.findIndex(({request_id}) => request_id === this.actionplan_campaign.request_id);
                    if (_campaign_completed_idx !== -1) {
                        _campaign_state = 1;
                    }
                }

                this.update_campaign_actionplan({
                    group: _campaign_state,
                    actionplan: _res_sumbit_actionplan.data
                });

                this.$EventBus.$emit('toast-success', this.$t('개선계획서 제출'), this.$t('성공적으로 제출하였습니다. 감사합니다.'));
                this.$bvModal.hide('managing-campaign-actionplan');
            } catch (error) {
                if (error.response) {
                    const {status} = error.response;
                    const data = getErrorMessage(error, '');
                    if (status === 400 && data === 'Empty_Company_ActionPlan_Contents') {
                        alert(this.$t('개선계획서 제출중 빈 파일로 확인되어 제출되지 않았습니다. 귀사의 시스템을 확인 또는 QESG에 문의해주시기 바랍니다.'));
                        return false;
                    } else if (status === 404 && data === 'Not_Found_ActionPlan') {
                        alert(this.$t('죄송합니다. 해당 평가의 개선계획이 조회되지 않습니다. QESG에 문의해주시기 바랍니다.'));
                        return false;
                    } else if (status === 404 && data === 'Not_Found_Request') {
                        alert(this.$t('죄송합니다. 개선계획서 제출 도중 장애가 발생했습니다. QESG에 문의해주시기 바랍니다.'));
                        return false;
                    }
                }

                alert(this.$t('죄송합니다. 개선계획서 제출 중 장애가 발생했습니다. QESG에 문의해주시기 바랍니다.'));
            } finally {
                this.is_submitting_actionplan = false;
            }
        },
        date_to_string(date) {
            if (date === 'None') {
                return this.$t('미정');
            } else {
                if (this.isIE === true) {
                    let txt_date = date.replace('-', '/');
                    return ih.dateToString(txt_date);
                } else {
                    return ih.dateToString(date);
                }
            }
        },
        async saveVisitLog() {
            try {
                const formData = new FormData();
                formData.append('campaign_id', this.campaign_in_progress.campaign_id);
                formData.append('user_id', this.user_id);

                await this.$axios.post('/save_visit_log', formData);
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.common_401_error_handling();
                    }
                }
            }
        },
        async informAuditors(mode) {
            // 특정 기업이 평가 클릭했을 때 Auditor에게 알리는 기능 ...saveVisitLog와 셋트임. 일단 사용하지 않음
            const path = this.$store.state.backend_host + '/inform_auditors';

            const formData = new FormData();
            formData.append('campaign_id', this.campaign_id);
            formData.append('company_id', this.company_id);
            formData.append('mode', mode); //'start_campaign', 'end_campaign'

            await this.$axios.post(path, formData);
        },
        async downloadResultReport(_report, _report_type) {
            let company_id = null;
            let project_code = null;

            this.report_download_loading = true;
            const h = this.$createElement;

            if (_report[_report_type]) {
                company_id = _report[_report_type].company_id;
                project_code = _report[_report_type].project_code;
            } else {
                this.$showModal({
                    type: 'alert',
                    state: 'danger',
                    title: this.$t('결과보고서 다운로드 오류'),
                    message: h('div', {}, [
                        h('div', {}, this.$t('죄송합니다. 결과보고서 다운로드에 필요한 정보가 올바르지 않습니다.')),
                        h('div', {}, this.$t('QESG(info@qesg.co.kr)로 문의해주세요.'))
                    ])
                });
                this.report_download_loading = false;
                return;
            }

            try {
                const _res_report_pdf = await this.$axios.post('/report/download', {
                    project_code: project_code,
                    company_id_list: [company_id],
                    mode: _report_type,
                    type: 'pdf'
                }, {
                    responseType: 'blob'
                }
                );

                const _report_pdf_blob = new Blob([_res_report_pdf.data], {type: 'application/pdf'});

                const link = document.createElement('a');
                link.href = URL.createObjectURL(_report_pdf_blob);
                link.setAttribute('download', _report[_report_type].report_name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (e) {
                this.$showModal({
                    type: 'alert',
                    state: 'danger',
                    title: this.$t('결과보고서 다운로드 오류'),
                    message: h('div', {}, [
                        h('div', {}, this.$t('죄송합니다. 결과보고서 다운로드 중 오류가 발생했습니다.')),
                        h('div', {}, this.$t('QESG(info@qesg.co.kr)로 문의해주세요.'))
                    ])
                });
            } finally {
                this.report_download_loading = false;
            }
        },
        async showCompanyReport(_report, _report_type, only_report_url = false) {
            try {
                let _selected_report = null;
                if (_report[_report_type]) {
                    _selected_report = {..._report[_report_type]};
                } else if (_report['report']) {
                    _selected_report = {..._report.report};
                } else {
                    throw new Error('Not_Found_Report_Data');
                }

                const {project_code, campaign_name, company_id, company_name} = _selected_report;
                this.view_target_report = {
                    project_code, campaign_name, company_id, company_name,
                    report_type: _report_type.toLocaleLowerCase(),
                    report: _selected_report,
                    mode: only_report_url ? 'download' : 'view'
                };

                this.$nextTick(() => {
                    this.$bvModal.show('showing-campaign-report');
                });

            } catch (error) {
                console.log(error);
                alert(this.$t('죄송합니다. 결과보고서를 다운로드 하는 도중 장애가 발생했습니다. QESG info@qesg.co.kr 로 문의해주시기 바랍니다.'));
            } finally {
                // if (!only_report_url) {
                //     // this.is_viewing_report = false
                // }
            }
        },
        initializeReportViewer() {
            this.view_target_report = null;
        },
        badges(status_code) {
            if (status_code == 'in_progress') return 'primary';
            if (status_code == 'in_assessment') return 'danger';
            if (status_code == 'completed') return 'success';
            else return 'advance';
        },
        status_txt(status_code) {
            if (status_code == 'in_progress') return this.$t('참여중');
            if (status_code == 'in_assessment') return this.$t('평가중');
            if (status_code == 'completed') return this.$t('평가완료');
            if (status_code == 'canceled') return this.$t('취소됨');
            else return this.$t('미시작');
        },
        campaign_access_status_mapping(_access_status) {
            const _access_status_mapping = {
                '0': '평가 참여중',
                '1': '평가 참여 대기중',
                '2': '평가 참여 거부'
            };

            // return this.$t(_access_status_mapping[_access_status])
            return _access_status_mapping[_access_status];
        },
        campaign_access_status_mapping_color(_access_status) {
            const _access_status_colors = {
                '0': 'primary',
                '1': 'warning',
                '2': 'danger'
            };

            return this.$t(_access_status_colors[_access_status]);
        },
        calculateActionplanRestDate(audit_sended_at) {
            if (!audit_sended_at) {
                return ' - ';
            }
            if (this.$i18n.locale === 'ko') {
                return dayjs(audit_sended_at).subtract(-14, 'days').format('YYYY-MM-DD 19:00');
            } else if (this.$i18n.locale === 'en') {
                return `KST ${dayjs(audit_sended_at).subtract(-14, 'days').format('MM-DD-YYYY 19:00')}`;
            } else {
                return `KST ${dayjs(audit_sended_at).subtract(-14, 'days').format('YYYY-MM-DD 19:00')}`;
            }

        }
    }
};
</script>

<style>
.vue-pdf-embed > div {
    margin-bottom: 8px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

#main-tabs__BV_tab_controls_ > li > a {
    color: var(--gray-600);
    font-size: 1.1rem;
}

#main-tabs__BV_tab_controls_ > li > .nav-link.active {
    color: var(--gray-700);
    border-color: var(--gray-700) var(--gray-700) var(--gray-100);
}

#main-tabs__BV_tab_controls_ {
    border-bottom: 1px solid var(--gray-700);
}
</style>

<style scoped lang="scss">
.intro-camp-card {
    min-width: 30%;
    min-height: 100%;
    border: 1.5px solid rgba(0, 0, 0, 0);

    & > h5 {
        transition: all 0.2s ease;
    }

    &:hover {
        border: 1.5px solid var(--gray-400);

        & > h5 {
            color: black;
        }
    }
}
</style>
<style>
.camp-overlay {
    margin: 0px;
}

.camp-overlay > .b-overlay > .bg-light {
    background-color: var(--gray-300) !important;
}

.camp-overlay > .b-overlay > div.position-absolute {
    min-width: 80%;
}

.disabled-card {
    cursor: not-allowed !important;
    pointer-events: none !important;
    opacity: 0.6;
    /* 클릭 불가능한 카드의 불투명도 조절 */
    z-index: 100 !important;
}

.report-loading-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    z-index: 10000 !important;
}
</style>
